import React from "react";

import FormModal from "./form";

import { connect } from "react-redux";
import { getFormSuccess, getFormError, createTask, updateTask, formReset } from "../../../../redux/actions/quote/show";

import {
    CACHE_UNIT,
    CACHE_SERVICE,
    CACHE_LANGUAGE,
    CACHE_LANGUAGE_PAIR,
    loadCache,
    isCacheLoading,
    isCacheLoaded,
    getServicesById,
    getServicesForSelect,
    getCategoriesForSelect,
    getUnitsForSelect,
    getLanguagesForSelect,
    getLanguagePairsForSelect,
    getUnitsIgnoreMTForSelect,
} from "../../../../redux/actions/cache/interface";

import { getDateTimeApiFormat, getTimezone } from "../../../../core/utils/timezones";
import { isNotValid, translateSymfonyErrorToFormik } from "../../../../core/utils/form";

/**
 * Container:
 *
 *   Se encarga de la conexion entre Redux y el Componente  que presenta los datos
 *
 * De paso en algunos caso, excepto formularios se maneja el Loading y el título.
 *
 * OBS: En formularios es mejor que el 'loading' lo maneje el formulario dado que Formik
 *    si se redibuja pierde los datos, entonces hay que tener cuidado con eso.
 */
class Container extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.loadCache();
    }

    componentDidUpdate(prevProps) {}

    componentWillUnmount() {
        this.props.formReset();
    }

    /**
     * Función que maneja el submit del formulario
     *
     * Recordar que se puede tratar de un alta o una edición
     */
    _handleSubmit = (values, bag) => {
        /*
        const deadlineAtTimezone = getTimezone(values.deadlineAt);
        const deadlineAt = getDateTimeApiFormat(values.deadlineAt);
        */

        const form = {
            ...values,
            /*
            deadlineAtTimezone: deadlineAtTimezone,
            deadlineAt: deadlineAt,
            */
        };

        let ret;

        if (!this.props.task) {
            ret = this.props.createTask(this.props.id, JSON.stringify(form));
        } else {
            ret = this.props.updateTask(this.props.id, this.props.task.id, JSON.stringify(form));
        }

        ret.then((response) => {
            if (isNotValid(response)) {
                bag.setErrors(translateSymfonyErrorToFormik(response.errors.children));
                bag.setSubmitting(false);
            } else {
                if (this.props.success) {
                    this.props.handleCancel();
                    //                    bag.resetForm();
                } else {
                    bag.setSubmitting(false);
                }
            }
        }).catch((e) => {
            bag.setSubmitting(false);
            alert("Se ha producido un error desconocido");
        });
    };

    render() {
        /*const { data, loading, alta, visible } = this.props;*/

        return (
            <FormModal
                visible={this.props.visible}
                initialValues={this.props.initialValues}
                handleSubmit={this._handleSubmit}
                handleCancel={this.props.handleCancel}
                catlogs={this.props.catlogs}
                task={this.props.task}
                {...this.props}
            />
        );
    }
}

const cacheList = [CACHE_SERVICE, CACHE_UNIT, CACHE_LANGUAGE, CACHE_LANGUAGE_PAIR];

function MapStateToProps(state) {
    return {
        error: getFormError(state),
        success: getFormSuccess(state),

        loading: isCacheLoading(state, cacheList),
        loaded: isCacheLoaded(state, cacheList),

        servicesById: getServicesById(state),
        services: getServicesForSelect(state),
        categories: getCategoriesForSelect(state),
        languagePairs: getLanguagePairsForSelect(state),
        languages: getLanguagesForSelect(state),

        units: getUnitsIgnoreMTForSelect(state),
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        formReset: () => dispatch(formReset()),

        createTask: (id, form) => dispatch(createTask(id, form)),
        updateTask: (jobId, taskId, form) => dispatch(updateTask(jobId, taskId, form)),

        loadCache: () => loadCache(cacheList)(dispatch),
    };
};

export default connect(MapStateToProps, mapDispatchToProps)(Container);
